export enum R_SsoRoutes {
  SsoNew_TokenNo_TokenRefNo = "/sso/new",
  SsoOld_TokenNo_TokenRefNo = "/sso/old",
}
export enum R_LoginRoutes {
  login = "/login",
  maximumOtpAttempt = "/maximumOtpAttempt",
  policyAndConditions = "/policy-&-conditions",
}
export enum R_OnBoardingRoutes {
  onboarding = "/onboarding",
}
export enum R_SecondaryChannelRoutes {
  fromSecondaryChannel = "/channel",
}
export enum R_PseudoLoginRoutes {
  fromPseudoLogin = "/pseudoLogin",
}
export enum R_GeneralElementsRoutes {
  setMpin = "/set-mpin",
  search = "/search",
  notifications = "/notifications",
  biometric_setup = "/biometricSetup",
  appTracker = "/appTracker",
  taxCenter = "/taxCenter",
}
export enum R_HomeRoutes {
  home = "/home",
  noHoldings = "/no-holdings",
}
export enum R_LiRoutes {
  li_baseUrl = "/details/li",
  details_PolicyNumber = "/details/li",
  details_PolicyNumber_TaxCertificate = "/details/li/tax-certificate",
  details_PolicyNumber_PolicyAccountStatement = "/details/li/policy-account-statement",
  details_PolicyNumber_PremiumReceipts = "/details/li/premium-receipts",
  addUpdate_nominee = "/details/li/add-update-nominee",
  details_PolicyNumber_UpdatePAN = "/details/li/update-PAN",
  detail_PolicyNumber_AddUpdateBankAccount = "/details/li/addUpdate-bankAccount",
  details_set_alerts = "/details/li/set-alerts",
  li_UrlNotFound = "li/not-found",
}
export enum R_HiRoutes {
  hi_baseUrl = "/details/hi",
  edit_hi_policy_details = "/details/hi/edit",
  details_PolicyNumber_EditPolicy = "/details/hi/edit-policy",
  details_PolicyNumber = "/details/hi",
  details_PolicyNumber_MedicalReports = "/details/hi/medical-reports",
}
export enum R_MfRoutes {
  mutualFund_BaseUrl = "/mutual-fund",
  mutualFund_Details = "/mutual-fund/details",
  mutualFund_CapitalGains = "/mutual-fund/capital-gains",
  mutualFund_AccountStatement = "/mutual-fund/account-statement",
  mutualFund_ExitLoad = "/mutual-fund/exit-load-statement",
}
export enum R_SSRoutes {
  details_baseUrl = "/my-portfolio",
  details_Portfolio = "/my-portfolio",
  details_Portfolio_MyDocuments = "/my-portfolio/my-documents",
  account_statement = "/my-portfolio/my-documents/account_statement",
  contact_notes = "/my-portfolio/my-documents/contacts-notes",
}
export enum R_HLRoutes {
  home_loan_baseUrl = "/details/hl",
  home_loan_details = "/details/hl",
  interest_certificate = "/details/hl/interest-certificate",
  account_statement = "/details/hl/account-statement",
  change_enach = "/details/hl/register-change-e-nach",
  document_upload = "/details/hl/document-upload",
  emi_payment = "/details/hl/emi-payment",
  disbursement_request = "/details/hl/disbursement-request",
  terms_and_conditions = "/details/hl/termsandconditions",
  home_loan_service_request = "/details/hl/service-request",
  change_address = "/details/hl/change-address",
  excess_emi_refund = "/details/hl/excess-emi-refund",
  home_loan_change_mobile = "/details/hl/change-mobile",
  home_loan_change_emi_tenure = "/details/hl/change_emi_tenure",
  home_loan_change_emi_tenure_charges = "/details/hl/change_emi_tenure/charges",
  home_loan_change_emi_tenure_option3 = "/details/hl/change_emi_tenure/moreOption",
  home_loan_change_emi_date = "/details/hl/change-emi-date",
  home_loan_tds_request = "/details/hl/tds-refund",
  home_loan_change_email = "/details/hl/change-email",
  Balance_Confirmation_Letter = "/details/hl/Balance-Confirmation-Letter",
  change_emi_select_date = "/details/hl/change-emi-select-date",
  change_emi_upload_doc = "/details/hl/change-emi-upload-doc",
}

export enum R_ABCDRoutes {
  viewAll_transaction = "/transaction-details",
}
